import { render, staticRenderFns } from "./blue.vue?vue&type=template&id=6648e564&"
import script from "./blue.vue?vue&type=script&lang=js&"
export * from "./blue.vue?vue&type=script&lang=js&"
import style0 from "./blue.vue?vue&type=style&index=0&id=6648e564&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzOffline: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/offline/index.vue').default,RzNotificationCenter: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/notification-center/index.vue').default,BaseHeader: require('/opt/yamal.ru/src/components/base/header/index.vue').default,BaseFooter: require('/opt/yamal.ru/src/components/base/footer.vue').default})
